import * as React from 'react';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IBellAlertIconProps {
  stroke?: string;
}
export const BellAlertIcon: React.FunctionComponent<IBellAlertIconProps> = ({ stroke = `${'#000000'}`, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...rest}>
      <g
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_6458_57681)"
      >
        <path d="M17.5 2.917l-.816.544M18.333 7.5h-.815M2.5 2.917l.816.544M1.667 7.5h.815M11.667 16.667a2.084 2.084 0 01-3.334 0M5.312 10.877V8.02a4.688 4.688 0 019.375 0v2.856h-.003l1.075 1.076a1.666 1.666 0 01-1.18 2.844H5.42a1.667 1.667 0 01-1.179-2.844l1.075-1.076"></path>
      </g>
      <defs>
        <clipPath id="clip0_6458_57681">
          <path fill="#fff" d="M0 0H20V20H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.memo(BellAlertIcon);
